import { render, staticRenderFns } from "./KanbanChangeDialog.vue?vue&type=template&id=f6281308&scoped=true&lang=pug&"
import script from "./KanbanChangeDialog.vue?vue&type=script&lang=ts&"
export * from "./KanbanChangeDialog.vue?vue&type=script&lang=ts&"
import style0 from "./KanbanChangeDialog.vue?vue&type=style&index=0&id=f6281308&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6281308",
  null
  
)

export default component.exports